export default __webpack_public_path__ + "static/media/bg-stage1.e86026f5.jpg";